import { render, staticRenderFns } from "./order_step3.vue?vue&type=template&id=596a5cf1&scoped=true&"
import script from "./order_step3.vue?vue&type=script&lang=js&"
export * from "./order_step3.vue?vue&type=script&lang=js&"
import style0 from "./order_step3.vue?vue&type=style&index=0&id=596a5cf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a5cf1",
  null
  
)

export default component.exports